<template>
  <div class="guestPassConfirm full-height">
    <ld-header>
      服务信息填写
    </ld-header>

    <div>
      <div>
        <van-cell>服务信息</van-cell>
        <van-field
          label="航班号"
          :placeholder="$t('MU9855','请输入航班号')"
          maxlength="10"
          v-model="flightNo"
          readonly
          @click.stop="inputNo"
        >
          <template #button>
            <span
              class="dBtn main-color"
              @click.stop="myFlight('myFlights')"
            >
              {{ $t('J052','我的航班') }}
            </span>
          </template>
        </van-field>

        <van-field
          label="服务时间"
          placeholder="建议航班起降前5小时预订及退改"
          v-model="serverTime"
          is-link
          @click="showDate = !showDate"
          input-align="left"
          readonly
        />
      </div>

      <!-- <div class="list">
        <span class="font16 font-bold">备注</span>
      </div> -->
      <van-cell>备注</van-cell>
      <van-field
        type="textarea"
        rows="3"
        autosize
        maxlength="50"
        show-word-limit
        placeholder="例如：报备车牌、举牌迎接，等"
        v-model="serverRemark"
      />
    </div>

    <!-- 底部导航 -->
    <ld-tabbar
      ref="tabbar"
      :price-list="priceList"
    >
      <van-row
        type="flex"
        align="center"
        justify="space-between"
        class="bg-white full-width shadow list"
      >
        <van-col span="8">
          <span class="font12 money-color">&yen;</span><span
            class="font22 money-color"
          > 
            <span v-show="searchInfo.pricingModel==1">
              {{ (searchInfo.salePrice+searchInfo.serviceFee) }}
            </span>
            <span v-show="searchInfo.pricingModel==2">
              {{ (searchInfo.baseSalesPrice||0)+ (searchInfo.salePrice+searchInfo.serviceFee) }}
            </span>
          </span>
          <span class="font10 gray">/人次</span>
        </van-col>
        <van-col span="8" />
        <van-col
          span="8"
          class="pad-r-8"
        >
          <ld-button
            :loading="false"
            size="md"
            main
            @click.native="book"
          >
            下一步
          </ld-button>
        </van-col>
      </van-row>
    </ld-tabbar>

    <!--  -->   
    <van-popup
      :lock-scroll="true"
      v-model="showDate"
      :close-on-popstate="true"
      position="bottom"
    >
      <van-datetime-picker
        v-model="datePicker"
        type="datetime"
        :min-date="minDate"
        @cancel="showDate != false"
        @confirm="dateSel"
      />
    </van-popup>

    <!--航班列表  -->
    <car-flights
      ref="myFlights"
      :data="myFlightData"
      @selected="flightSel"
      :use-type="myflt"
    />

    <!-- 查询航班 -->
    <query-flights
      ref="queryFlights"
      @selected="queryFlights"
      @getParams="getFlight"
      :depart-time="serverTime"
      :depport="depport"
      :arrport="arrport"
      :show-tab="true"
      readonly
    />
  </div>
</template>

<script>
import {Field,Cell,Stepper,Popup,DatetimePicker} from 'vant'
import { mapGetters } from 'vuex'
import { formatDate ,getPreStrTime} from 'Utils/dateUtil'
import ldButton from 'Common/ldButton'
import ldTabbar from 'Components/ldTabbar/ldTabbar'
import carFlights from 'Views/Car/carQuery/flight/carFlights'
import queryFlights from 'Views/Car/carQuery/flight/queryCarFlights'
// const newdate=formatDate(new Date())

export default {
  name: 'GuestPassConfirm',
  components:{
    [Field.name]: Field,
    [Cell.name]: Cell,
    [Stepper.name]: Stepper,
    [Popup.name]: Popup,
    [DatetimePicker.name]: DatetimePicker,
    ldTabbar,
    ldButton,
    carFlights,
    queryFlights
  },
  data () {
    return {
      pnum:1,
      flightNo:'',
      serverTime:'',//服务时间 //newdate.date+' '+newdate.hm,
      departDate:'',//起飞时间
      priceList: [],
      showDate: false,
      datePicker: new Date(),
      minDate: new Date(),
      linker:{},
      serverRemark:'',
      myflt:false,
      myFlightData: [], //航班列表
      relateOrder:'',//关联订单号
      flightInfo:{}
    }
  },
  computed: {
    ...mapGetters({
      userInfo:'userInfo',
      searchInfo: 'guestPass/searchInfo',
      params: 'guestPass/params',
      travelerList:'guestPass/travelerList'
    }),
    depport(){
      if(this.params.serverType==2){//送机
        return {
          jcZdName:this.params.serverAirportName,
          jcZdCode:this.params.serverAirportCode,
          threeCode:this.params.serverAirportCode,
          cityName:this.params.cityName,
        }
      }
      return {}
    },
    arrport(){
      if(this.params.serverType==1){//接机
        return {
          jcZdName:this.params.serverAirportName,
          jcZdCode:this.params.serverAirportCode,
          threeCode:this.params.serverAirportCode,
          cityName:this.params.cityName,
        }
      }
      return {}
    }
  },
  created () {
  },
  methods:{
    book(){
      if(this.flightNo){
        this.$store.commit('guestPass/params',{
          serverTime:this.serverTime,
          departDate:this.departDate,
          flightNo:this.flightNo,
          serverRemark:this.serverRemark,
          relateOrder:this.relateOrder
        })
        this.$store.commit('guestPass/flightInfo',this.flightInfo)
        this.$router.push({path:'/guestPass/edit'})
      }else{
        this.$toast('请输入航班号！')
      }
    },
    queryFlights(flight,date) {
      this.myflt=false
      this.toggle('myFlights',{data:flight,date:date})
    },
    myFlight(name) {
      this.myflt=true
      //获取系统内机票订单
      //业务类型 1接送 2送机 不能为空
      this.$api['common/queryWcxOrder']({ ywlx: 1 }).then(res => {
        let cache = res.data || []
        cache.reverse()
        if (cache.length > 0) {
          this.myFlightData = cache
          this.toggle(name)
        } else {
          this.$toast('未查询到您的航班信息')
        }
      })
    },
    inputNo(){
      this.toggle('queryFlights')
    },
    dateSel(date){
      this.showDate=false
      this.serverTime= formatDate(date).datehm
    },
    getFlight(flight){
      if(this.params.serverType==2){//送机
        if(this.params.serverAirportCode!=flight.departAirport){
          this.$dialog.alert({
            title: '提示',
            message: '您选择的航班的机场与当前服务机场不是同一机场，请重新选择！',
          }).then(() => {
            // on close
          })
          return
        }
      }else{
        if(this.params.serverAirportCode!=flight.arriveAirport){
          this.$dialog.alert({
            title: '提示',
            message: '您选择的航班的机场与当前服务机场不是同一机场，请重新选择！',
          }).then(() => {
            // on close
          })
          return
        }
      }
      this.flightInfo=flight
      this.relateOrder=flight.orderNo
      this.flightNo=flight.flightNo
      this.departDate=formatDate(flight.departTime).date
      this.datePicker=new Date(flight.departTime)
      if(this.params.serverType==1){//接机
        this.serverTime=formatDate(flight.arriveTime).datehm
      }else{
        this.serverTime=formatDate(getPreStrTime(flight.departTime,-5)).datehm
      }
    },
    flightSel(flight){
      if(this.params.serverType==2){//送机
        if(this.params.serverAirportCode!=flight.departAirport){
          this.$dialog.alert({
            title: '提示',
            message: '您选择的航班的机场与当前服务机场不是同一机场，请重新选择！',
          }).then(() => {
            // on close
          })
          return
        }
      }else{
        if(this.params.serverAirportCode!=flight.arriveAirport){
          this.$dialog.alert({
            title: '提示',
            message: '您选择的航班的机场与当前服务机场不是同一机场，请重新选择！',
          }).then(() => {
            // on close
          })
          return
        }
      }
      this.flightInfo=flight
      this.relateOrder=''
      this.flightNo=flight.flightNo
      this.departDate=formatDate(flight.departTime).date
      this.datePicker=new Date(flight.departTime)
      if(this.params.serverType==1){//接机
        this.serverTime=formatDate(flight.arriveTime).datehm
      }else{
        this.serverTime=formatDate(getPreStrTime(flight.departTime,-5)).datehm
      }
      if(this.travelerList.length==0){
        this.userInfo.empInfo.checked=true
        this.userInfo.empInfo.clkFlag=2
        this.$store.commit('guestPass/travelerList',[this.userInfo.empInfo])
      }
    },
    toggle(name,params) {
      this.$refs[name].toggle(params)
    },
  },
  watch: {
  }
}
</script>

<style lang="less" scoped>
.list{
    padding: 10px;
}
.box{
    padding-bottom: 5px;
}
.dBtn {
    display: inline-block;
    width: 1.35rem;
    height: 0.48rem;
    line-height: 0.46rem;
    text-align: center;
    border-radius: 24px;
    border: 1px solid;
    font-size: @font-size-12;
}
</style>
